import { ChangeDetectionStrategy, Component, HostListener, inject, Signal } from '@angular/core';
import { IconModule } from "@ogs-gmbh/ngx-m3-components";
import { TableColumnMenuService } from '../../services/table-column-menu.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatRipple, MatRippleModule } from '@angular/material/core';
import { TranslationPipeModule } from '@ogs-gmbh/ngx-translate';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faEyeSlash } from '@fortawesome/pro-light-svg-icons';
import { TableColumn } from '@shared/components/table-implementation/types/column/header.type';
import { TableConfigService } from '@core/services/table/table-config.service';
import { MatListItem } from '@angular/material/list';

@Component({
  selector: 'app-table-column-menu-item-change-visibility',
  standalone: true,
  imports: [ IconModule, MatRippleModule, TranslationPipeModule, MatListItem ],
  templateUrl: './table-column-menu-item-change-visibility.component.html',
  styleUrl: './table-column-menu-item-change-visibility.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [ MatRipple ]
})
export class TableColumnMenuItemChangeVisibilityComponent {
  private _faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  private _tableColumnMenuService: TableColumnMenuService = inject(TableColumnMenuService);

  private readonly _tableConfigService: TableConfigService = inject(TableConfigService);

  protected header: Signal<TableColumn | undefined> = toSignal(this._tableColumnMenuService.header$);

  constructor () {
    this._faIconLibrary.addIcons(faEyeSlash);
  }

  @HostListener("click")
  protected onClick (): void {
    if (!this.header()) return;

    // eslint-disable-next-line @tseslint/no-non-null-assertion
    this._tableConfigService.changeColumnVisibility(this.header()!.field, false);
  }
}
